import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ae4b6b5a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("En esta página puedes formar grupos de tus alumnos. Y para cada grupo puedes agregar tareas o materiales de estudio.")
const _hoisted_3 = { class: "container" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Mis grupos:", -1))
const _hoisted_5 = { class: "list-group-item-success" }
const _hoisted_6 = { class: "mt-3" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "far fa-trash-alt" }, null, -1))
const _hoisted_8 = {
  key: 0,
  class: "container"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Todos los grupos", -1))
const _hoisted_10 = { class: "list-group-item-success" }
const _hoisted_11 = { class: "mt-3" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "bi bi-plus-circle" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_card_text = _resolveComponent("b-card-text")!
  const _component_b_card = _resolveComponent("b-card")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_b_button = _resolveComponent("b-button")!
  const _component_b_card_group = _resolveComponent("b-card-group")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", null, "¡Hola " + _toDisplayString(_ctx.currentUser.firstname) + "!", 1),
    _createVNode(_component_b_card, {
      "border-variant": "light",
      class: "m-4 porque-nosotros-card",
      style: {"min-width":"300px"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_b_card_text, null, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("ul", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userGroups || [], (group) => {
          return (_openBlock(), _createElementBlock("li", {
            key: group,
            class: "container__list d-flex flex-column items-list"
          }, [
            _createVNode(_component_b_card, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_b_card_group, { deck: "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_b_card, {
                        "bg-variant": "light",
                        class: "text-center"
                      }, {
                        footer: _withCtx(() => [
                          _createVNode(_component_b_button, {
                            onClick: ($event: any) => (_ctx.handleDeleteGroupe(group.id), _ctx.$toast('Borrado de tus grupos')),
                            pill: "",
                            class: "btn-lg button-delete align-self-center"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_7
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_router_link, {
                            to: '/group/' + group.id
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_b_card_text, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(group.groupname), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024)
                ])
              ]),
              _: 2
            }, 1024)
          ]))
        }), 128))
      ])
    ]),
    _createVNode(_component_b_button, {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isHiddenFormToCreate = !_ctx.isHiddenFormToCreate)),
      pill: "",
      class: "b-card__button mb-5 mt-5 w-100"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.isHiddenFormToCreate ? "Mostrar todos los grupos" : "Ocultar los grupos"), 1)
      ]),
      _: 1
    }),
    (!_ctx.isHiddenFormToCreate)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("ul", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groups || [], (group) => {
              return (_openBlock(), _createElementBlock("li", {
                key: group,
                class: "container__list d-flex flex-column items-list"
              }, [
                _createVNode(_component_b_card, null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_component_b_card_group, { deck: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_b_card, {
                            "bg-variant": "light",
                            class: "text-center"
                          }, {
                            footer: _withCtx(() => [
                              _createVNode(_component_b_button, {
                                onClick: ($event: any) => (_ctx.handleAddToMyGroups(group.id), _ctx.$toast('Añadido a tus grupos')),
                                pill: "",
                                class: "btn-lg button-delete align-self-center"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_12
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_router_link, {
                                to: '/group/' + group.id
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_b_card_text, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(group.groupname), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1032, ["to"])
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ])
                  ]),
                  _: 2
                }, 1024)
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}